import React, { useEffect, useState } from 'react';
import { Spin, Space, Row, Col, Card, Tooltip, Table , notification, Input} from 'antd';
import { history } from '../../redux/store';
import axios from "axios";
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting'
import {
  PlusCircleTwoTone,
} from '@ant-design/icons';


const CovidTesting = () => {
  const [CovidTestData, setCovidTestData] = useState([]);
  const [CovidTotalTests, setCovidAllTests] = useState([]);
  const [change, setChange] = useState(false);  
  const [searchFieldVal, searchField] = useState("");
  const [covidTestEmpEvent, setcovidTestEmpEvent] = useState([]);
  const [CovidTestDataLength, setCovidTestDataLength] = useState(0);
  const [CovidTestDataApproved, setCovidTestDataApproved] = useState([]);
  const [CovidTestDataApprovedLength, setCovidTestDataApprovedLength] = useState(0);
  const [CovidTestDataPendingLength, setCovidTestDataPendingLength] = useState(0);
  const [CovidTestDataPending, setCovidTestDataPending] = useState([]);
  

  useEffect(() => {
    getData();
  
  }, [])

  function download(e, attachment_url) {
    
    axios.post(setting.serverUrl + '/api/downloadTestingCertificate', {
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        // pass: localStorage.getItem('myPass'),
        attachment_url: attachment_url
      }
    }).then(response => {
      
      window.open(response.data);
    })
  }

  function getData() {

    let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
  
    axios.post(setting.serverUrl + '/api/getEmployeeCovidTest', {
      params:
      {
        email: localStorage.getItem('myData'),
        user: localStorage.getItem('myData'),
        // pass: localStorage.getItem('myPass'),
        customerId: employeeData?employeeData.company[0]:'',
        employeeId : employeeData?employeeData.id:''
      }
    }).then(response => {
        setChange(!change)
        if (response && response.status == 200)
        {
            if(response.data && response.data.error){
              notification['error']({
                message: 'Error',
                description: response.data.error
              })
            }

            if(Array.isArray(response.data) && response.data.length>0)
            {
                let CovidTestDataApproved = response.data.filter(function (e) {
                    return e.testing_status == 'approved';
                });

                let CovidTestDataPending = response.data.filter(function (e) {
                  return e.testing_status == 'pending';
                });
              
                setCovidTestData(response.data)
                let total= response.data;
                setCovidAllTests(total)
                setCovidTestDataLength(response.data.length)
                setCovidTestDataApproved(CovidTestDataApproved);
                setCovidTestDataApprovedLength(CovidTestDataApproved.length)
                setCovidTestDataPending(CovidTestDataPending)
                setCovidTestDataPendingLength(CovidTestDataPending.length)
                setcovidTestEmpEvent(response.data);
                setChange(!change)
            }
        }
        else
        {
          notification['error']({
            message: 'Error',
            description: 'There is some technical issue. Please try again later.'
          })
        }
    })

  }

 
const columns = [
    
    {
      title: 'Test Name',
      key: 'test_type',
      dataIndex: 'test_type',
      sorter: (a, b) => a.test_type.length - b.test_type.length,
      render: (test_type) => (
        <span className='nowrap'>
          <strong>{test_type}</strong>
        </span>
      )
    },
    {
      key: 'test_date',
      dataIndex: 'test_date',
      title: 'Test Date',
      sorter: (a, b) => moment(a.test_date).unix() - moment(b.test_date).unix(),
    
      render: (test_date) => (
        <span className='nowrap'>
          <strong> {test_date ? moment(test_date).format("MM/DD/YYYY") : ''}</strong>
        </span>
      )
    }, 
    {
      key: 'test_result',
      dataIndex: 'test_result',
      title: 'Test Result',
      sorter: (a, b) => a.test_result.length - b.test_result.length,
    
      render: (test_result) => (
      test_result === 'Positive'?
        <span style={{color:'red', fontSize:12, fontWeight:600}}>{test_result}</span>
        :
        <span style={{color:'green', fontSize:12, fontWeight:600}}>{test_result}</span>
      )
    },
   
  
    {
      key: 'testing_status',
      dataIndex: 'testing_status',
      title: 'Status',
      sorter: (a, b) => a.testing_status.length - b.testing_status.length,
     
      render: (testing_status) => <strong>{testing_status}</strong>
    },
    
    {
      key: 'approval_date',
      dataIndex: 'approval_date',
      title: 'Approval Date',
      // sorter: (a, b) => a.testing_status.length - b.testing_status.length,
      // sorter: (a, b) => (a.name > b.name ? 1 : -1),
      render: (approval_date) => <strong>{approval_date?moment(approval_date).format("MM-DD-YYYY hh:mm a"):''}</strong>
    },
    {
      key: 'conducted_by',
      dataIndex: 'conducted_by',
      title: 'Conducted By',
    
      render: (conducted_by) => <strong>{conducted_by}</strong>
    },
    {
      key: 'attachment_url',
      dataIndex: 'attachment_url',
      title: 'Documents',
      
      render: (attachment_url) => (
        <span className='nowrap'>
           {!(attachment_url) ? null : <button  onClick={(e) => download(e, attachment_url)}>Preview</button> }
        </span>
      )
    }
   
  ];
 

function addCovidTest() {
  history.push({ pathname: `/vertical/addCovidTest`, state: {} });
}


  return (
    <div style={{ padding: 30 }}>

      <div className='row'>

        <div className='col-12 col-md-6 col-xl-2' style={{ cursor: 'pointer' }}>

          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'
           onClick={() => setCovidTestData(CovidTotalTests)}>

            <div className='row'>

              <div className='col-12' style={{ textAlign: 'center' }}>

                <div className='count' style={{ fontSize: 40, color: '#EF6827', lineHeight: 1.4, fontWeight: 'bold' }}>

                  {CovidTotalTests.length}

                </div>

                <h6 className='mt-0 mb-1' style={{ color: '#707070' }}> Total<br /> Tests</h6>

              </div>

            </div>

          </Card>

        </div>
        {/* Approved */}
        <div className='col-12 col-md-6 col-xl-2' style={{ cursor: 'pointer' }}>

          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'
         onClick={() => setCovidTestData(CovidTestDataApproved)}>

            <div className='row'>





              <div className='col-12' style={{ textAlign: 'center' }}>

                <div className='count' style={{ fontSize: 40, color: '#2F7197', lineHeight: 1.4, fontWeight: 'bold' }}>

                  {CovidTestDataApprovedLength}

                </div>

                <h6 className='mt-0 mb-1' style={{ color: '#707070' }}><br /> Approved</h6>

              </div>

            </div>

          </Card>

        </div>

        {/* pending */}
        <div className='col-12 col-md-6 col-xl-2' style={{ cursor: 'pointer' }}>
          <Card style={{ background: 'rgba(251, 251, 251)' }} className='animated with-shadow'
         onClick={() => setCovidTestData(CovidTestDataPending)}>
            <div className='row'>
              <div className='col-12' style={{ textAlign: 'center' }}>
                <div className='count' style={{ fontSize: 40, color: '#2F7197', lineHeight: 1.4, fontWeight: 'bold' }}>
                  {CovidTestDataPendingLength}
                </div>
                <h6 className='mt-0 mb-1' style={{ color: '#707070' }}><br /> Pending</h6>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <Row>
        <Col span={4}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Covid Tests</h3>
        </Col>
        <Col span={2}>
          <Tooltip placement="top" title="Add Test Event">
            <PlusCircleTwoTone style={{ fontSize: 25, marginTop: 40, cursor: 'pointer' }}
              onClick={addCovidTest}
            />
          </Tooltip>
        </Col>
        <Col span={10}></Col>
        <Col span={8}>
        <Input
      style={{ backgroundColor: 'white', marginTop:30}}
      placeholder="Type to search..."
      suffix={<span className='icofont icofont-search' />}
      value={searchFieldVal}
      onChange={(e) => {
      searchField(e.target.value)
    if (e.target.value.length > 0) {
    let datArr = covidTestEmpEvent.filter(val =>
      
      val.test_type.length > 0 && val.test_type.toLowerCase().includes(e.target.value.toLowerCase()) ||
      val.test_result && val.test_result.toLowerCase().includes(e.target.value.toLowerCase())||
      val.testing_status && val.testing_status.toLowerCase().includes(e.target.value.toLowerCase())||
      val.conducted_by && val.conducted_by.toLowerCase().includes(e.target.value.toLowerCase())
     

    );
    setCovidTestData(datArr)
     } else {
    setCovidTestData(covidTestEmpEvent)
  }
}}
/>
        </Col>
      </Row>

      {CovidTestData.length > 0 ?
        <div>
          <Card>

            <div className='row'>
              <div className='col-12 col-md-12 col-xl-12' >

                <Table
            
                  dataSource={CovidTestData}
                  columns={columns}
              
                />

              </div>
            </div>

          </Card>


        </div>
        :
        change ?
          <Row>
            <Col span={10}>
            </Col>
            <Col span={8}>
              <Space size="large" style={{ marginTop: 30 , color:"red"}}>

              <p style={{ fontSize: 18, fontWeight: 700, padding: 20, color: 'red' }}>
                No Record Found!
              </p>

              </Space>
            </Col>
          </Row>
          :
          <Row>
            <Col span={10}>
            </Col>
            <Col span={8}>
              <Space size="large" style={{ marginTop: 30 }}>

                <Spin size="large" />

              </Space>
            </Col>
          </Row>
      }

    </div>
  );
};



export default CovidTesting;